export default __webpack_public_path__ + "static/media/instagram.de287935.svg";